import React from 'react';

export default function GettingStarted() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-[var(--color-primary)] mb-8">
        Başlangıç Kılavuzu
      </h1>

      <div className="prose prose-lg max-w-none">
        <h2>SolarTools'a Hoş Geldiniz</h2>
        <p>
          Bu kılavuz, SolarTools platformunu kullanmaya başlamanız için gereken temel bilgileri içerir.
          Adım adım talimatlarla sistemin kurulumunu ve temel özelliklerini öğreneceksiniz.
        </p>

        <h3>1. Hesap Oluşturma</h3>
        
          Portal üzerinden kayıt olun
          E-posta doğrulamasını tamamlayın
          Profil bilgilerinizi güncelleyin
        

        <h3>2. İlk Dashboard'unuzu Oluşturun</h3>
        
          Dashboard oluşturma sihirbazını başlatın
          Şablon seçin veya sıfırdan başlayın
          Widget'ları ekleyin ve düzenleyin
        

        <h3>3. Cihaz Bağlantısı</h3>
        
          Yeni cihaz ekleyin
          Bağlantı bilgilerini alın
          Test verilerini görüntüleyin
        

        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 my-6">
          <p className="text-blue-700">
            <strong>İpucu:</strong> Başlamadan önce sistem gereksinimlerini kontrol etmeyi unutmayın.
          </p>
        </div>
      </div>
    </div>
  );
} 